import { FC } from 'react'
import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { Button, Switch } from '@pepper/ui'

import s from './StatsWrapper.module.css'

type Props = {
  headerText: string
  children: React.ReactNode
  handleTabChange: (tab: 'DISTRIBUTED' | 'LIST') => void
  activeTab: 'DISTRIBUTED' | 'LIST'
  footer?: string
  showSwitch?: boolean
  handleViewMore?: () => void
  showBack?: boolean
  handleToggle?: () => void
  showNonBranded?: boolean
}

export const StatsWrapper: FC<Props> = ({
  children,
  headerText,
  showSwitch = false,
  handleTabChange,
  activeTab,
  handleViewMore,
  showBack = false,
  handleToggle,
  showNonBranded,
}) => {
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div
          className={clsx(s.headerText, {
            [s.headerTextBack]: showBack,
          })}
        >
          {showBack && (
            <Button
              icon={<Icon icon="lucide:arrow-left" />}
              onClick={handleViewMore}
            />
          )}
          {headerText}
          {showBack}
          {activeTab === 'LIST' && !showBack && (
            <Button type="link" onClick={handleViewMore}>
              {' '}
              View More
            </Button>
          )}
        </div>
        <div className={s.actionables}>
          {showSwitch && (
            <div className={s.switch}>
              Show only Non-Branded Keywords
              <Switch
                checked={showNonBranded}
                onChange={() => handleToggle?.()}
              />
            </div>
          )}
          {!showBack && (
            <>
              <div className={s.actionsWrapper}>
                <div className={s.toggle}>
                  <button
                    onClick={() => handleTabChange('DISTRIBUTED')}
                    className={clsx(s.toggleBtn, {
                      [s.active]: activeTab === 'DISTRIBUTED',
                    })}
                  >
                    Distribution
                  </button>
                  <button
                    onClick={() => handleTabChange('LIST')}
                    className={clsx(s.toggleBtn, {
                      [s.active]: activeTab === 'LIST',
                    })}
                  >
                    List
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className={s.childrenWrapper}>{children}</div>
    </div>
  )
}
